'use client'

import React, { useContext } from 'react'

import { useLanguages } from '@/hooks'

import { HeaderContext } from '../context'

export const BurgerMenu: React.FC = () => {
  const { t } = useLanguages()
  const { onToggleMenu } = useContext(HeaderContext)

  return (
    <div id="burger-wrapper" onClick={onToggleMenu}>
      <div id="burger">
        <div></div>
        <span>{t('menu')}</span>
      </div>
    </div>
  )
}
